<template>
  <AuthComponent @result="handleAuth"/>

  <v-container>
    <v-row>
      <v-col cols="10">
        <v-card-title>Dashboard</v-card-title>
      </v-col>
      <v-col cols="2" align="right">
        <v-btn>New...</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <v-card variant="outlined">
          <v-card-item>Tickets</v-card-item>
          
          <v-row>
            <v-col cols="12" lg="3">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ opentickets.length }} <v-chip color="blue" size="small">Open</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
            <v-col cols="12" lg="3">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ pendingtickets.length }} <v-chip color="orange-darken-1" size="small">Pending</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
            <v-col cols="12" lg="3">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ duetickets.length }} <v-chip color="orange-darken-1" size="small">Due Today</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
            <v-col cols="12" lg="3">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ pastduetickets.length }} <v-chip color="red" size="small">Past Due</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card variant="outlined">
          <v-card-item>Alerts</v-card-item>

          <v-row>
            <v-col cols="12" lg="6">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ warningalerts.length }} <v-chip color="orange-darken-1" size="small">Warning</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
            <v-col cols="12" lg="6">
              <v-card-item>
                <v-card variant="flat" link>
                  <v-card-item>
                    <v-card-title>{{ criticalalerts.length }} <v-chip color="red" size="small">Critical</v-chip></v-card-title>
                  </v-card-item>
                </v-card>
              </v-card-item>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card variant="outlined">
          <v-card-item>Ticket Stats</v-card-item>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card variant="outlined">
          <v-card-item>Stale Customers</v-card-item>
  
        </v-card>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthComponent from '@/components/AuthComponent.vue';
import { defineComponent } from 'vue';

// Components

export default defineComponent({
  name: 'DashboardView',

  components: {
    AuthComponent
  },

  data: () => ({
    auth : null,
    opentickets : [],
    pendingtickets : [],
    duetickets : [],
    pastduetickets : [],
    warningalerts : [],
    criticalalerts : []
  }),

  methods:{
    handleAuth(value){
      this.auth = value;
      this.refreshView();
    },
    refreshView(){
      
    }
  }
});
</script>